(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pt-BR", [], factory);
	else if(typeof exports === 'object')
		exports["pt-BR"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["pt-BR"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 